import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";
import { myOptions } from "src/components/users/UserForm";
import { timeOffsTypes } from "./types";

export const fields: FilterFieldConfig[] = [
    { key: "type", label: "Type", type: "select", default: "",
        options: [
            { value: "", label: "Select" },
            ...timeOffsTypes.map(t => ({ value: t, label: t })),
        ],
    },
    { key: "status", label: "Status", type: "select", default: "",
        options: [
            { value: "",             label: "Select" },
            { value: "Submitted",    label: "Submitted" },
            { value: "Re-Submitted", label: "Re-Submitted" },
            { value: "Approved",     label: "Approved" },
            { value: "Rejected",     label: "Rejected" },
        ],
    },
    { key: "fromDate", label: "From Date", type: "range", default: "", inputType: "date" },
    { key: "toDate", label: "To Date", type: "range", default: "", inputType: "date" },
    
    // data
    { key: "totalHours", label: "Total Hours", type: "range", default: "", inputType: "number" },

    { key: "notes", label: "Notes", type: "text", default: "" },
    { key: "requesterId", label: "Requester", type: "asyncSelect", default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search user…",
        isMulti: false,
    },
    { key: "department", label: "Department", type: "select", default: "",
        options: [
            { value: "", label: "Select" },
            ...Object.entries(myOptions.department).flatMap(([group, values]) =>
                (values as string[]).map(v => ({ value: v, label: `${group} - ${v}` }))
            ),
        ],
    },
    { key: "approverId", label: "Approver", type: "asyncSelect", default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search user…",
        isMulti: false,
    },
    { key: "paid", label: "Paid", type: "select", default: "no",
        options: [
        { value: "no", label: "No" },
        { value: "yes", label: "Yes" },
        { value: "all", label: "All" },
        ],
    },
    { key: "notifiedBy", label: "Notified By", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php", 
        placeholder: "Search User", 
        isMulti: false, 
    },
    { key: "notifiedAt", label: "Notified At", type: "range", default: "", inputType: "date" },
    { key: "approvalTime", label: "Decision Time", type: "range", default: "", inputType: "date"},
    { key: "approverNotes", label: "Approver Notes", type: "text", default: "" },
    { key: "creatorId", label: "Created By", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php", 
        placeholder: "Search User", 
        isMulti: false, 
    },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    { key: "updaterId", label: "Updated By", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php", 
        placeholder: "Search User", 
        isMulti: false, 
    },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
    { key: "void", label: "Validity", type: "select", default: "no",
        options: [
        { value: "no", label: "Valid" },
        { value: "yes", label: "Void" },
        { value: "all", label: "All" },
        ],
    },
    { key: "voidReason", label: "Void Reason", type: "text", default: "" },
    { key: "validateReason", label: "Validate Reason", type: "text", default: "" },
];
export default function TimeOffFilterForm() {
    return <FilterModal title="Filter" width={650} fields={fields} />;
}
